export default __webpack_public_path__ + "static/media/playStoreLogo.21e033c0.png";